// Mock data for the admin dashboard & lists
const names = [
  "Aarav Sharma", "Vivaan Patel", "Aditya Rao", "Ananya Iyer", "Diya Nair",
  "Ishaan Menon", "Kabir Reddy", "Meera Kapoor", "Neha Verma", "Rohan Gupta",
  "Saanvi Joshi", "Aryan Malhotra", "Riya Choudhary", "Kavya Bansal", "Advait Pillai",
  "Zara Khan", "Devansh Agarwal", "Aisha Rahman", "Yash Trivedi", "Tanvi Sinha",
  "Krish Ahuja", "Naina Bhat", "Vihaan Desai", "Anika Sethi", "Reyansh Grover",
  "Pari Chatterjee", "Arjun Saxena", "Myra Kulkarni", "Kiaan Bhattacharya", "Siya Deshmukh",
  "Aadhya Salunkhe", "Shaurya Mishra", "Rudra Tiwari", "Aarohi Mehta", "Anaya Krishnan",
];

const statuses = ["submitted", "verified", "pending", "rejected", "reupload"];
const weights = [45, 30, 15, 5, 5];

const pickStatus = (i) => {
  const total = weights.reduce((a, b) => a + b, 0);
  const r = ((i * 37) % total) + 1;
  let acc = 0;
  for (let j = 0; j < statuses.length; j++) {
    acc += weights[j];
    if (r <= acc) return statuses[j];
  }
  return statuses[0];
};

const dateFor = (i) => {
  const now = new Date("2026-02-15T10:00:00");
  const d = new Date(now.getTime() - i * 3600 * 1000 * 6);
  return d.toISOString();
};

export const MOCK_APPLICATIONS = names.map((n, i) => ({
  id: `APP${(2026001 + i).toString()}`,
  applicationNumber: `MU2026${(1001 + i).toString()}`,
  ackNumber: `MU-BBA-2026-${(100000 + i * 137).toString().slice(-6)}`,
  name: n,
  email: `${n.toLowerCase().replace(/\s+/g, ".")}@student.mahindra.edu`,
  mobile: `+91 9${(800000000 + i * 12345).toString().slice(0, 9)}`,
  nationality: i % 8 === 0 ? "NRI" : "Indian",
  status: pickStatus(i),
  submittedAt: dateFor(i),
  progress: 60 + (i * 7) % 40,
  photo: `https://i.pravatar.cc/160?img=${(i % 70) + 1}`,
  documents: [
    { name: "10th Certificate", status: (i + 1) % 5 === 0 ? "reupload" : "verified" },
    { name: "12th Certificate", status: "verified" },
    { name: "Transfer Certificate", status: (i + 2) % 6 === 0 ? "pending" : "verified" },
    { name: "Migration Certificate", status: "verified" },
    { name: "Tuition Fee Receipt", status: "verified" },
    { name: "Hostel Fee Receipt", status: i % 4 === 0 ? "pending" : "verified" },
    { name: "Offer Letter", status: "verified" },
    { name: "Bonafide", status: "verified" },
    { name: "Aadhaar", status: "verified" },
    { name: "Anti Ragging Affidavit", status: (i + 3) % 7 === 0 ? "rejected" : "verified" },
    { name: "Nationality Proof", status: "verified" },
  ],
  history: [
    { at: dateFor(i + 3), event: "Application created" },
    { at: dateFor(i + 2), event: "Documents uploaded" },
    { at: dateFor(i + 1), event: "Submitted for review" },
    { at: dateFor(i), event: "Under review by admissions" },
  ],
}));

export const STATUS_META = {
  not_started: { label: "Not Started", color: "bg-slate-100 text-slate-700 ring-slate-300" },
  in_progress: { label: "In Progress", color: "bg-amber-50 text-amber-700 ring-amber-200" },
  draft: { label: "In Progress", color: "bg-amber-50 text-amber-700 ring-amber-200" },
  submitted: { label: "Submitted", color: "bg-blue-50 text-blue-700 ring-blue-200" },
  roadmin_cleared: { label: "RO Approved", color: "bg-indigo-50 text-indigo-700 ring-indigo-200" },
  verified: { label: "Approved", color: "bg-green-50 text-green-700 ring-green-200" },
  pending: { label: "Pending", color: "bg-amber-50 text-amber-700 ring-amber-200" },
  rejected: { label: "Rejected", color: "bg-red-50 text-red-700 ring-red-200" },
  reupload: { label: "Reupload", color: "bg-orange-50 text-orange-700 ring-orange-200" },
  // Student called at their slot but not available — parked until RO releases them.
  on_hold: { label: "On Hold", color: "bg-slate-100 text-slate-700 ring-slate-300" },
  withdrawn: { label: "Withdrawn", color: "bg-red-50 text-red-700 ring-red-200" },
};

// Filters shown on the Applications list (All is always available separately).
// roadmin_cleared used to sit here, but the two-phase roadmin->saadmin flow
// was disabled — roadmin approval now goes straight to 'verified', so that
// status never actually occurs and the filter chip always returned zero
// results. 'verified' (Approved) is the one that's actually reachable.
export const APPLICATION_STATUS_FILTERS = [
  "submitted",
  "verified",
  "reupload",
  "rejected",
  "on_hold",
  "withdrawn",
];

// Trend series (submissions per day)
export const TREND_DATA = Array.from({ length: 14 }).map((_, i) => {
  const d = new Date("2026-02-01T00:00:00");
  d.setDate(d.getDate() + i);
  const base = 8 + Math.round(Math.sin(i / 2) * 5 + i * 1.4);
  return {
    date: d.toLocaleDateString("en-IN", { day: "2-digit", month: "short" }),
    submissions: Math.max(3, base),
    verified: Math.max(2, base - 3 - (i % 3)),
  };
});
